import React from 'react';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import { WORLD_LANGUAGE_SUBJECTS_IDS } from 'chameleon-src/constants/subjects';

const AddToQuizAction = (props) => {
  const {
    router,
    subjectId,
    subunitTitle,
    item,
    topicQuestionsFilter,
    unitNumber,
  } = props;
  const onClick = () => {
    const itemTitlePrefix = WORLD_LANGUAGE_SUBJECTS_IDS.includes(
      parseInt(subjectId, 10),
    )
      ? `Unit ${unitNumber}: `
      : '';
    router.push({
      pathname: `/${subjectId}/question_bank/create/auto-build/filters`,
      state: {
        topicQuestionsFilter,
        quizTitle: `${itemTitlePrefix}${subunitTitle} Quiz`,
        quizItems: [item.itemId],
      },
    });
  };

  return (
    <ButtonWithIcon
      isIcon
      isNaked
      tabIndex={0}
      onClick={onClick}
      icon="add"
      iconClassName="text-gray-700"
      accessibility={{
        'aria-label': 'Assign quiz',
      }}
    />
  );
};

AddToQuizAction.propTypes = {
  router: PropTypes.object.isRequired,
  subjectId: PropTypes.number.isRequired,
  subunitTitle: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
};

AddToQuizAction.defaultProps = {};

export default AddToQuizAction;
